import { render } from "./ChinhSuaThongTinCaNhan.vue?vue&type=template&id=2222e2b9"
import script from "./ChinhSuaThongTinCaNhan.vue?vue&type=script&lang=js"
export * from "./ChinhSuaThongTinCaNhan.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__